// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"80395e710a0df1283955","293":"5b0c9eeb4e4ca01fe111","518":"ac313d5448d54f91925f","779":"2b8c3afa03e601620141"}[chunkId] + ".js";
};